var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeatStressLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 104,
    viewBox: "0 0 6 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 31",
    d: "M3.5 4.57227L5.88675 -0.427735L0.113249 -0.427734L2.5 4.57227L3.5 4.57227ZM2.5 4.07227L2.50001 136.572L3.50001 136.572L3.5 4.07227L2.5 4.07227Z",
    fill: "#EB4B4B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeatStressLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Heat_Stress_Line.8e23d5bd5f976dba16f18a4570dd6fff.svg";